var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonPartShow"},_vm._l((_vm.commonPartArr),function(item,index){return _c('div',{key:index,staticStyle:{"display":"inline-block"}},[_vm._v("\n    "+_vm._s(item.name)+"："+_vm._s(item.number)),(item.isShow)?_c('span',{staticStyle:{"display":"inline-block"}},[_vm._v("，")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }